import {
  Box,
  ToggleButtonGroup,
  ToggleButton,
  TextField,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import { Refresh as RefreshIcon, FilterList as FilterListIcon } from '@mui/icons-material';
import { useTranslation } from '@/kit/useTranslation';

export default function TransactionFilters({
  filter,
  onFilterChange,
  dateRange,
  onDateRangeChange,
  onRefresh,
  loading,
  totalCount,
}) {
  const { t } = useTranslation();
  return (
    <Box sx={{ mb: 3 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center" gap={1}>
          <FilterListIcon color="action" />
          <Typography variant="h6">{t('payment.filters.filters')}</Typography>
          {totalCount > 0 && (
            <Typography variant="body2" color="text.secondary">
              {t('payment.filters.transactionsCount', { count: totalCount })}
            </Typography>
          )}
        </Box>
        <Tooltip title={t('payment.filters.refreshTransactions')}>
          <IconButton onClick={onRefresh} disabled={loading} color="primary">
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Type Filter */}
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary" mb={1}>
          {t('payment.filters.transactionType')}
        </Typography>
        <ToggleButtonGroup
          value={filter}
          exclusive
          onChange={(e, newFilter) => {
            if (newFilter !== null) {
              onFilterChange(newFilter);
            }
          }}
          size="small"
          fullWidth
        >
          <ToggleButton value="all">{t('payment.filters.all')}</ToggleButton>
          <ToggleButton value="credit">{t('payment.filters.moneyAdded')}</ToggleButton>
          <ToggleButton value="debit">{t('payment.filters.payments')}</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Date Range Filter */}
      <Box>
        <Typography variant="body2" color="text.secondary" mb={1}>
          {t('payment.filters.dateRange')}
        </Typography>
        <Box display="flex" gap={2}>
          <TextField
            type="date"
            label={t('payment.filters.from')}
            value={dateRange.start || ''}
            onChange={(e) => onDateRangeChange({ ...dateRange, start: e.target.value })}
            InputLabelProps={{ shrink: true }}
            size="small"
            fullWidth
          />
          <TextField
            type="date"
            label={t('payment.filters.to')}
            value={dateRange.end || ''}
            onChange={(e) => onDateRangeChange({ ...dateRange, end: e.target.value })}
            InputLabelProps={{ shrink: true }}
            size="small"
            fullWidth
          />
        </Box>
      </Box>
    </Box>
  );
}
